import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "ui/components/dialog";
import ButtonWithLoading from "@/components/button-with-loading";

export default function CreateFolderDialog({
    open,
    onOpenChange,
    onConfirm,
    isLoading,
    project,
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Create Folder</DialogTitle>
                    <DialogDescription>
                        By proceeding, a new Drive Folder named "{project}"
                         will be created for this project.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <ButtonWithLoading
                        onClick={onConfirm}
                        isLoading={isLoading}
                        disabled={isLoading}
                        variant="default"
                    >
                        Yes, Create
                    </ButtonWithLoading>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
